import { getDefaultHeaders } from "./utils";

export const saveAnnotations = async (data, panelIndex, comicId) => {
  const headers = await getDefaultHeaders(true, true);
  headers['Content-Type'] = 'application/json';

  const payload = {
    ...data,
    panel_index: panelIndex,
    comic_id: comicId.id,
  };

  try {
    const response = await fetch(`/api/save-annotations/`, {
      headers: headers,
      method: 'POST',
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.detail || 'Failed to save annotations');
    }
    return { success: true, data: await response.json() };
  }
  catch (error) {
    console.error('Error in saveAnnotations API call:', error);
    return { success: false, error: error.message };
  }
};